import * as React from 'react'

import { Icon, IconProps } from './Icon'

export const UserFilledIcon: React.FC<IconProps> = props => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g transform="translate(2, 2)">
      <path
        fill="currentColor"
        d="M10 10C9.08333 10 8.29861 9.67361 7.64583 9.02083C6.99306 8.36806 6.66667 7.58333 6.66667 6.66667C6.66667 5.75 6.99306 4.96528 7.64583 4.3125C8.29861 3.65972 9.08333 3.33333 10 3.33333C10.9167 3.33333 11.7014 3.65972 12.3542 4.3125C13.0069 4.96528 13.3333 5.75 13.3333 6.66667C13.3333 7.58333 13.0069 8.36806 12.3542 9.02083C11.7014 9.67361 10.9167 10 10 10ZM3.33333 16.6667V14.3333C3.33333 13.8611 3.45486 13.4271 3.69792 13.0313C3.94097 12.6354 4.26389 12.3333 4.66667 12.125C5.52778 11.6944 6.40278 11.3715 7.29167 11.1563C8.18056 10.9410 9.08333 10.8333 10 10.8333C10.9167 10.8333 11.8194 10.9410 12.7083 11.1563C13.5972 11.3715 14.4722 11.6944 15.3333 12.125C15.7361 12.3333 16.059 12.6354 16.3021 13.0313C16.5451 13.4271 16.6667 13.8611 16.6667 14.3333V16.6667H3.33333Z"
      />
    </g>
  </Icon>
)
